module.exports = __webpack_public_path__ + "static/shipkoo-express-1-a2fac9f995b41b2efc3f018f18999e84.png";